module.exports = __webpack_public_path__ + "static/media/n02.5b1ecd29.jpg";